module.exports = __webpack_public_path__ + "files/5e25815e10d2f5f616fdf9a342f1294a.png";